module.exports = __webpack_public_path__ + "static/img/column_img_8-2.1476e5bb.png";